<template>
    <v-layout wrap v-if="server && chargerName && numberPlugs">
        <v-flex xs12>
            <v-alert color="primary" outlined dense>
                <v-flex xs12 class="text-right">
                    <strong>Configuração de pagamento de parceiro stripe: </strong>
                    <v-row align="center">
                        <v-col cols="6">
                            <v-select label="Configuração" v-model="configuration" :items="configurationOptions" outlined dense>
                                <template v-slot:item="{ item }">
                                    <div>
                                        <div class="font-weight-bold">{{ item.name }}</div>
                                        <div class="caption text--secondary">{{ item.description }}</div>
                                    </div>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span>{{ item.name }}</span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="6" v-if="configuration && configuration.valueDescription">
                            <v-autocomplete :items="configuration.optionsDescription" :label="configuration.valueDescription" v-model="value" outlined dense
                                v-if="configuration.optionsDescription && configuration.optionsDescription.length" />
                            <v-text-field :label="configuration && configuration.valueDescription ? configuration.valueDescription : '-'" v-model="value" v-else />
                        </v-col>
                    </v-row>
                    <v-btn small color="error" class="ma-1 white--text" @click="changeConfiguration"> Enviar </v-btn>
                </v-flex>

                <pre>{{ response }}</pre>
            </v-alert>
        </v-flex>
        <ConfirmModal ref="confirm" />
    </v-layout>
</template>

<script>
import ConfirmModal from "@/components/core/ConfirmModal";

const configurationOptions = [
    {
        name: "Buscar dominio",
        description: "Buscar os dominios de pagamento configurados na conta conectada (Apple Pay)",
        method: "GET",
        endpoint: "payment_method_domains",
        body: {},
    },
    {
        name: "Criar dominio",
        description: "Criar um novo dominio de pagamento na conta conectada (Apple Pay)",
        valueDescription: "Digite o domínio (ex: https://incharge.app)",
        optionsDescription: ["https://pay.incharge.app", "https://pay4charge.com", "https://incharge.app", "https://dev.pay4charge.com", "https://dev.incharge.app"],
        method: "POST",
        endpoint: "payment_method_domains"
    },
];

export default {
    props: {
        chargerName: {
            type: String,
            required: true,
        },
        numberPlugs: {
            type: Number,
            required: true,
        },
        server: {
            type: String,
            required: true,
        },
        config: {
            type: Object,
            required: false,
        }
    },

    components: { ConfirmModal },

    data() {
        return {
            configuration: null,
            configurationOptions,
            value: "",
            response: "",
        };
    },

    computed: {
        formattedResponse() {
            if (!this.response) return '';
            try {
                if (typeof this.response === 'string') {
                    return JSON.stringify(JSON.parse(this.response), null, 2);
                }
                return JSON.stringify(this.response, null, 2);
            } catch (e) {
                return this.response;
            }
        }
    },

    methods: {
        sendCommand(url, parameters) {
            if (this.server) {
                this.response = "";
                this.$http
                    .postDynamic(this.server, url, parameters)
                    .then((result) => {
                        if (result) {
                            this.response = result;
                        }
                        this.$eventHub.$emit("msgSuccess", "Enviado com sucesso.");
                    }).catch((error) => {
                        this.$eventHub.$emit("msgError", error.message ? error.message : "Erro ao enviar, tente novamente.");
                    });
            } else {
                this.$eventHub.$emit("msgError", "Falta configuração do servidor.");
            }
        },
        confirmAndSent(msg, url, parameters) {
            this.$refs.confirm.open("Confirma?", msg).then((confirm) => {
                if (confirm) this.sendCommand(url, parameters);
            });
        },
        changeConfiguration() {
            if (this.configuration && this.configuration.endpoint && this.configuration.method && this.configuration.name) {
                let body = {};

                if (this.configuration.endpoint == "payment_method_domains") {
                    body = { domain_name: this.value };
                }

                this.confirmAndSent(`Deseja realmente enviar '${this.configuration.name}'?`, "api/v2/payment/configure/stripe", { charger: this.chargerName, method: this.configuration.method, endpoint: this.configuration.endpoint, body });
            } else {
                this.$eventHub.$emit("msgError", "Preencha a configuração.");
            }
        },
    },
};
</script>